// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamFilterButtons__grid___nUG94 {
    align-items: center;
    display: grid;
    gap: 0;
    grid-template-columns: repeat(4, max-content);
    justify-content: center;
    margin: 3px auto;
    max-width: 900px;
}

.DreamFilterButtons__grid___nUG94 > span {
    min-width: 0;
    text-align: center;
}

.DreamFilterButtons__grid___nUG94 > span:nth-last-child(2):nth-child(4n + 1) {
    grid-column-start: 2;
}

.DreamFilterButtons__horizonGrid___K253Z {
    margin-top: 12px;
}

@media (max-width: 520px) {
    .DreamFilterButtons__grid___nUG94 {
        grid-template-columns: repeat(2, max-content);
        max-width: 100%;
    }

    .DreamFilterButtons__grid___nUG94 > span:nth-last-child(2):nth-child(4n + 1) {
        grid-column-start: auto;
    }

    .DreamFilterButtons__grid___nUG94 > span:last-child:nth-child(2n + 1) {
        grid-column: 1 / span 2;
    }

    .DreamFilterButtons__horizonGrid___K253Z {
        grid-template-columns: repeat(2, max-content);
    }

    .DreamFilterButtons__horizonGrid___K253Z > span:first-child {
        grid-column: 1 / span 2;
    }

    .DreamFilterButtons__horizonGrid___K253Z > span:last-child:nth-child(2n + 1) {
        grid-column: auto;
    }
}

.DreamFilterButtons__compositeItem___BYYo8 {
    align-items: center;
    display: flex;
    justify-content: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `DreamFilterButtons__grid___nUG94`,
	"horizonGrid": `DreamFilterButtons__horizonGrid___K253Z`,
	"compositeItem": `DreamFilterButtons__compositeItem___BYYo8`
};
module.exports = ___CSS_LOADER_EXPORT___;
